import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { API_URL, getOrderStatuses } from "../utils/api";

const CustomerViewLayer = () => {
    const [orders, setOrders] = useState([]);
    const [customerInfo, setCustomerInfo] = useState([]);
    const [statuschanged, setStatuschanged] = useState(false);
    const [servicesList, setServicesList] = useState([]);
    const [settingsList, setSettingsList] = useState([]);
     
  let { id } = useParams();

 
  useEffect(() => {
    // Fetch data

    axios
    .get(process.env.REACT_APP_API_BASE_URL+"customer-details/"+id)
    .then((response) => {
        console.log("response;", response);
        setCustomerInfo(response.data);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });


    axios
      .get(process.env.REACT_APP_API_BASE_URL+"order-all/customer/"+id)
      .then((response) => {
        setOrders(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

     axios
      .get(process.env.REACT_APP_API_BASE_URL + "/setting-list")
      .then((response) => {
        const settingdata = response.data.data;
        let settingarray = [];

        settingdata.map((srvc, index) => (settingarray[srvc.setting_key] = srvc.setting_value));
        setSettingsList(settingarray);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      }); 

        axios.get(process.env.REACT_APP_API_BASE_URL+"service-list")
                  .then(response => {
                    let services = response.data.data;

                    let servicearray = [];

                    services.map((srvc, index) => (servicearray[srvc.id] = srvc.title));
                    setServicesList(servicearray);
                    
                  })
                  .catch(error => {
                      console.error('Error fetching data:', error);
                  });

  }, [statuschanged]);
 let Orderstatuses=getOrderStatuses();

 
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };
let arraykeys={
    "1": "Discount_on_1st_Booking",
    "6": "Discount_on_6th_Booking",
    "12" : "Discount_on_12th_Booking"
}
 let indexarr = [1,6,12];
  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0"> Customer Profile</h5>
      </div>
      <ToastContainer></ToastContainer>
      <div className="card-body">
 
<div className="container">

<div className="row">
<div className="  col-6">
 <label className="form-label">Name:</label> {customerInfo.name}
</div>
<div className="  col-6">
<label  className="form-label">Email:</label> {customerInfo.email}
</div>
<div className="  col-6">
<label  className="form-label">Phone:</label> {customerInfo.phone}
</div>
</div>
<h5 className="card-title  " style={{fontWeight: "600",
    lineHeight: "60px",
    marginBottom: "0",
    fontSize: "26px !important"}}> Customer Orderwise Discount</h5>

<div className="row">

{orders.map((post, i) =>{ 
 
    if(orders.length <= 12 || (orders.length >12 && i>=12)){
        return (
         
            <div className="col-md-2 col-6" key={"i"+i}>
            <div className="bx-890">
            <h4>  {(indexarr.includes(i%12+1)) ? settingsList[arraykeys[i%12+1]]+" OFF":""}  </h4>
            </div>
            </div>
            )
    }
   })}

</div>


<h5 className="card-title"> Customer Orders List</h5>
 
          <table
                  className="table bordered-table mb-0"
                  id="dataTable"
                  data-page-length={10}
                >
                  <thead>
                    <tr>
                      <th scope="col">
                        <div className="form-check style-check d-flex align-items-center">
                          <label className="form-check-label">S.L</label>
                        </div>
                      </th>
                       <th scope="col">Service</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                        <th scope="col">Status</th>
                     <th scope="col">Created Date</th>
                          </tr>
                  </thead>
                  <tbody>
                    {orders.map((post, i) => (
                      <tr key={"staff" + i}>
                        <td>
                          <div className="form-check style-check d-flex align-items-center">
                            <label className="form-check-label">{i + 1}</label>
                          </div>
                        </td>
                          <td>{//servicesList[post.serviceId]
                          }
                          {
                //let serviceids ="";// post.serviceId.split(",")
                post.serviceId.split(",").map((id) => servicesList[id]+", ") }
                          </td>
                       <td>
        
         <Link  to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/customer-view/${post.user_id}`}
                                                className="text-success-main align-items-center justify-content-center"
                                            >
                                                {post.name}
                                            </Link>
        
                       </td>
                        <td>{post.email}</td>
                        <td>{post.phone}</td>
                           <td>{Orderstatuses[post.serviceStatus]}</td>
                        <td>{formatDate(post.createdAt)}</td>
                      
                      </tr>
                    ))}
                  </tbody>
                </table>

                </div>
      </div>
    </div>
  );
};

export default CustomerViewLayer;
